import { Banner } from "@foodpilot/foods";
import { Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
    deletedEntities: string;
};
export const AssociatedStructureWarning = (props: Props) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Banner
            variant={"themed"}
            colors={{
                color: theme.custom.orange[500],
                backgroundColor: theme.custom.orange[50],
                sideBorder: theme.custom.orange[500],
            }}
        >
            <Typography variant={"body-semibold"}>
                {t(
                    "entity.organization.unshare_modal.body",
                    "You are about to remove sharing for: {{companies}}. Data and questionnaire responses associated with this item for these companies will no longer be accessible. Do you want to continue?",
                    { companies: props.deletedEntities },
                )}
            </Typography>
        </Banner>
    );
};
